//#region Dropdown with search bar
var kdrDropdown = {
    search($item) {
        let $this = $item
        let value = $this.val().toLowerCase().trim()
        let items = $this.closest('.kdr-dropdown-w-search-menu').find('.kdr-dropdown-w-search-item')

        let matchedItems = []
        let notMatchedItems = []

        items.filter(function (v, e) {
            let $e = $(e)
            let iv = $e.text().toLowerCase()
            if (iv.includes(value)) {
                matchedItems.push($e[0])
            } else {
                notMatchedItems.push($e[0])
            }
        })

        kdrDropdown.hideItems(notMatchedItems)
        kdrDropdown.showItems(matchedItems)
        kdrDropdown.updatePlacement($this.closest('.kdr-dropdown-w-search-menu'))
    },
    hideItems(items) {
        $(items).addClass('hide')
    },
    showItems(items) {
        $(items).removeClass('hide')
    },
    selectItem($toggler, item, fireEventsP = false) {
        let $this = $(item)
        let val = $this.data('value')

        if (val == undefined) {
            console.info('Item to set in DDL must have value!')
            return;
        }

        //let $toggler = $this.closest('.dropdown-menu').data('toggler')
        let $ddl;
        if (!$toggler) {
            let menuId = $this.closest('.dropdown-menu').attr('id')
            $ddl = $('.kdr-dropdown-w-search-item_selected[data-target="' + menuId + '"]').closest('.kdr-dropdown-w-search')
            $toggler = $ddl.find('.kdr-dropdown-w-search-item_selected')
            $this.closest('.dropdown-menu').data('toggler', $toggler)
        } else {
            $ddl = $toggler.closest('.kdr-dropdown-w-search')
        }

        if ($ddl.length == 0) {
            console.log($this)
            throw 'Cannot find dropdown menu toggler for dropdownmenu'
        }

        let $destination = $toggler//$ddl.find('.kdr-dropdown-w-search-item_selected')

        if ($ddl.find('.kdr-dropdown-w-search_multi').length > 0) {
            let $checkbox = $this.data('checkboxInput');
            if (!$checkbox) {
                $checkbox = $this.find('[type="checkbox"]')
                $this.data('checkboxInput', $checkbox)
            }

            if ($destination.valExtended().includes(val)) {

                //$this.removeAttr('selected') //a na co to
                //$checkbox.removeAttr('checked')
                $checkbox.valExtended(false)
                $destination.find('.items_selected-text-item[data-value="' + $.escapeSelector(val) + '"]').remove()

            } else {
                let title = $this.data('htmlP') === true ? $this.data('htmlTitle') : $this.text()

                //$this.attr('selected', 'selected')
                //$checkbox.attr('checked', 'checked')
                $checkbox.valExtended(true)

                let $c = $destination.find('.items_selected-text-item-pattern').clone().detach()
                $c.find('.text-target').html(title)
                $c.attr('data-value', val)
                $destination.find('.item_selected-content-wrapper .items_selected-text').append($c)

                $c.removeClass('items_selected-text-item-pattern')
                kdrDropdown.initDeleteButton($ddl)
            }

            $destination.trigger('refreshSelectedList')

        } else {
            let $itemSelectedSpan = $destination.find('.item_selected-text')

            $destination.data('value', val)
            let $itemTextContainer = $this.find('.kdr-dropdown-w-search-item-text')
            if ($this.data('htmlP') === true) { //$this.find('.kdr-dropdown-w-search-item-text').children().length > 0
                $itemSelectedSpan.html($itemTextContainer.html())
            }
            else {
                $itemSelectedSpan.text($itemTextContainer.text())
            }

            if (fireEventsP) {
                $destination.trigger('change')
            }

            $destination.data('valueIsInvalid', false)
                .trigger({
                    type: 'kdr',
                    namespace: 'checkedValueCorrectness',
                    hasInvalidValue: false,
                    newValue: val
                })

        }
    },
    selectItems($toggler, items, fireEventsP = false, runAsyncP = true, afterChangeAllItemsCallback) {
        if (items != undefined && typeof (items) == 'object' && items.length > 0) {
            //let $mddl = $(items[0]).closest('.kdr-dropdown-w-search-menu').data('toggler').closest('.kdr-dropdown-w-search')
            //let menuId = $(items[0]).closest('.dropdown-menu').attr('id')
            let $mddl = $toggler.closest('.kdr-dropdown-w-search')
            let $menu = $($toggler.data('bs.dropdown')?._menu ?? '#' + $toggler.data('target'))

            $mddl.data('isMultiSelecting', true)

            $menu && loading.show($menu)
            loading.show($toggler.parent())

            for (var i = 0; i < items.length; i++) {
                let j = i
                let f = () => {
                    kdrDropdown.selectItem($toggler, items[j], fireEventsP)

                    if (j == items.length - 1) {
                        $mddl.data('isMultiSelecting', false)

                        $menu && loading.hide($menu)
                        loading.hide($toggler.parent())
                        afterChangeAllItemsCallback && afterChangeAllItemsCallback()
                    }
                }

                if (runAsyncP) {
                    setTimeout(() => f(), 0)
                } else {
                    f()
                }
            }
        }
    },
    removeSelectedItem(item) {
        let $this = $(item).closest('.items_selected-text-item')
        let val = $this.data('value')

        let $destination = $this.closest('.kdr-dropdown-w-search-item_selected')

        let menuId = $destination.data('target')
        let $i = $(`#${menuId} .kdr-dropdown-w-search-item[data-value="${val}"]`)

        kdrDropdown.selectItem($destination, $i)

        $destination.closest('.kdr-dropdown-w-search').trigger('hidden.bs.dropdown') //fixme, wyniesc oblsuge tego cuda do jakiejs funkcji albo czegos zeby nie robic tego na evencie

        kdrDropdown.checkIfUpdateShouldPerform($destination)
    },
    refreshSelectedList($kdrDropdown) {
        let $this = $($kdrDropdown).find('.kdr-dropdown-w-search-item_selected')
        let items = []
        let oldValue = $this.valExtended()
        $this.data('oldValue', oldValue)

        $this.find('.items_selected-text-item:not(.items_selected-text-item-pattern)').each(function (i, e) {
            items.push($(e).data('value'))
        })
        $this.data('value', items)

        kdrDropdown.checkCheckboxState($kdrDropdown)
        kdrDropdown.displaySelectedItemsCount($kdrDropdown)
        kdrDropdown.managePlaceholder($kdrDropdown)
    },
    initDeleteButton($kdrDropdown) {
        let $this = $($kdrDropdown)

        if ($this.hasClass('kdr-dropdown-w-search_multi')) {
            $this.find('.dismiss-item').on('click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                kdrDropdown.removeSelectedItem(this)
            })
        }
    },
    checkCheckboxState($kdrDropdown) {
        setTimeout(() => {
            let $this = $($kdrDropdown)

            let menuId = $this.find('.kdr-dropdown-w-search-item_selected').data('target')
            let $menu = $('#' + menuId)
            let $cb = $menu.find('.kdr-dropdown-w-search-select-all-checkbox')

            if ($cb == undefined || $cb.length == 0) {
                throw 'Cannot find checkbox for check all'
            }

            let selectedItemsCount = $this.find('.kdr-dropdown-w-search-item_selected').data('value').length
            let allItemsCount = $menu.find('.kdr-dropdown-w-search-items .kdr-dropdown-w-search-item').length

            if (selectedItemsCount > 0 && selectedItemsCount != allItemsCount) {
                tristateCheckbox.setIndeterminate($cb)
            } else {
                tristateCheckbox.setIndeterminate($cb, false)
                $cb.prop('checked', selectedItemsCount == allItemsCount)
            }

        }, 0)
    },
    /**
     * srawdza czy ma odpalic change'a na wybranym ddl'u i jezeli tak to odpala
     * @param {any} $ddl .kdr-dropdown-w-search-item_selected
     */
    checkIfUpdateShouldPerform($ddl) {
        if (false == $ddl.hasClass('kdr-dropdown-w-search-item_selected')) {
            //$ddl = $ddl.find('.kdr-dropdown-w-search-item_selected')
            $ddl = $ddl.data().toggler ?? $ddl.find('.kdr-dropdown-w-search-item_selected')
        }

        if ($ddl == undefined || $ddl.length == 0) {
            $ddl = $ddl.find('.kdr-dropdown-w-search-item_selected')
        }

        if ($ddl.closest('.kdr-dropdown-w-search_multi, .kdr-frax-dropdown').length > 0) {
            if (false == compare.arraysAreEqual($ddl.valExtended(), $ddl.data('oldValue') ?? [])) {
                $ddl.trigger('change')
            }
        } else {
            if (($ddl.valExtended() != ($ddl.data('oldValue') ?? '') && $ddl.valExtended() != undefined)) {
                $ddl.trigger('change')
            }
        }
    },
    displaySelectedItemsCount($kdrDropdown) {
        let $this = $($kdrDropdown)
        let selectedItemsCount = $this.find('.kdr-dropdown-w-search-item_selected').data('value').length
        $this.find('.items_selected_count').text(selectedItemsCount)
    },
    managePlaceholder($kdrDropdown) {
        let $dd = $($kdrDropdown)
        let $ph = $dd.find('.kdr-dropdown-w-search-placeholder')
        let itemsCount = $dd.find('.kdr-dropdown-w-search-item_selected').data('value').length
        if (itemsCount > 0) {
            $ph.addClass('hide')
        } else {
            $ph.removeClass('hide')
        }
    },
    updatePosition($kdrDropdownWSearchMenu) {
        $kdrDropdownWSearchMenu.each(function () {
            let $ddl = $(this)

            if ($ddl.closest('.kdr-grid-quick-filters').length != 0 ||
                $ddl.closest('.kdr-grid-hair').length != 0 ||
                $ddl.closest('.kdr-grid-scroll-horizontal').length != 0) {
                $ddl.closest('.kdr-grid').append($ddl.detach())
            }
            else if ($ddl.closest('.kdr-incell').length != 0) {
                $ddl.closest('.kdr-incell').append($ddl.detach())
            }
            else if ($ddl.closest('.kdr-questions-update').length != 0) {
                $ddl.closest('.kdr-questions-update').append($ddl.detach())
            }
            else if ($ddl.closest('.kdr-matrix').length != 0) {
                $ddl.closest('.kdr-matrix').append($ddl.detach())
            } else if ($ddl.closest('.as-search-results').length != 0) {
                $ddl.closest('.as-search-results').append($ddl.detach())
            } else if ($ddl.closest('.kdr-knowledge-base-user-tiles-parent').length != 0) {
                $ddl.closest('.kdr-knowledge-base-user-tiles-parent').append($ddl.detach())
            } else if ($ddl.closest('.kdr-frax-folder-group').length != 0) {
                $ddl.closest('.kdr-frax-folder-group').append($ddl.detach())
            } else if ($ddl.closest('.calendar-filter-bar').length != 0) {
                $ddl.closest('.content-body').append($ddl.detach())
            }
            else if($ddl.closest('.filters-table-parent').isAny()) {
                $ddl.closest('.kdr-filters-group').append($ddl.detach())
            }
        })
    },
    updatePlacement($kdrDropdownMenu) {
        $kdrDropdownMenu.data().toggler.dropdown('update')
    },
    /**
     * Syncs toggler data with multidropdown menu for this toggler.
     * @param {any} $kdrDropdownMenu
     */
    checkSelectedItems($kdrDropdownMenu) {
        let $toggler = $kdrDropdownMenu.data().toggler

        if ($toggler.parent().parent().hasClass('kdr-dropdown-w-search_multi')) {
            $kdrDropdownMenu.find('>>>>.kdr-custom-checkbox:checked').valExtended(false)
            let togglerData = $toggler.valExtended()

            for (var i = 0; i < togglerData.length; i++) {
                let dataIndex = togglerData[i]
                $kdrDropdownMenu.find('>>.kdr-dropdown-w-search-item[data-value="' + $.escapeSelector(dataIndex) + '"]>>.kdr-custom-checkbox').valExtended(true)
            }
        }
    },
    /**czysci mddl*/
    clearDropdown($kdrDropdownWSearch) {
        let $toggler = $kdrDropdownWSearch.find('.kdr-dropdown-w-search-item_selected')
        let $menu = kdrDropdown.getTogglerMenu($toggler)

        $($kdrDropdownWSearch.find('.kdr-dropdown-w-search-item_selected').valExtended()).each((i, e) =>
            kdrDropdown.selectItem($toggler, $menu.find('.kdr-dropdown-w-search-item[data-value="' + e + '"]')) //CHECK ME
        )
    },
    getItemName($kdrDropdownToggler, dataId) {
        let $menu = kdrDropdown.getTogglerMenu($kdrDropdownToggler)

        let $item = $menu.find(`.kdr-dropdown-w-search-item[data-value="${dataId}"] .kdr-dropdown-w-search-item-text`)
        return $item.length > 0 ? $item.text()?.trim() : null
    },
    getItemByName($kdrDropdownToggler, name) {
        let $menu = kdrDropdown.getTogglerMenu($kdrDropdownToggler)

        let $item = $menu.find(`.kdr-dropdown-w-search-item[title="${name}"]`)
        return $item.length > 0 ? $item : null
    },
    getTogglerMenu($kdrDropdownToggler) {
        let targetId = $kdrDropdownToggler.data('target')
        let $menu = $($kdrDropdownToggler.data('bs.dropdown')?._menu)
        if ($menu.length == 0) $menu = $('#' + targetId)

        return $menu
    }
}


/*to jest jakas patologia ze trzeba tak robic...*/
$(document).on('mouseenter', '.kdr-dropdown-w-search .dismiss-item', function (e) {
    $(this).attr('isMouseOver', true)
})

$(document).on('mouseleave', '.kdr-dropdown-w-search .dismiss-item', function (e) {
    $(this).attr('isMouseOver', false)
})

$(document).on('click', '.kdr-dropdown-w-search-item', function (e) {
    let $this = $(this)
    //let menuId = $this.closest('.dropdown-menu').attr('id')
    let $ddl = $this.closest('.dropdown-menu')
    let $toggler = $ddl.data().toggler ?? $ddl.closest('.kdr-dropdown-w-search').find('.kdr-dropdown-w-search-item_selected')
    if ($toggler.closest('.kdr-dropdown-w-search_multi').length > 0) {
        e.preventDefault()
        e.stopPropagation()
    }

    kdrDropdown.selectItem($toggler, $this, false)
})

$(document).on('input', '.kdr-dropdown-w-search_bar', function () {
    kdrDropdown.search($(this))
})

$(document).on('click', '.kdr-dropdown-w-search-menu .kdr-dropdown-w-search-check,'
    + '.kdr-dropdown-w-search-menu .kdr-dropdown-w-search_bar,'
    + '.kdr-dropdown-w-search-menu .kdr-dropdown-w-search-new-item-input'
    , function (e) {
        e.stopPropagation()
    })

$(document).on('show.bs.dropdown', '.kdr-dropdown-w-search', function (e) {
    let $dismissItemWithMouseOver = $(e.target).find('.dismiss-item[ismouseover="true"]')
    if ($dismissItemWithMouseOver.length == 0) {
        let $this = $(this)

        let $toggler = $this.data('toggler')
        let $dropdownMenu = $this.data('dropdownMenu')

        if ($toggler == undefined || $toggler.length == 0) {
            $toggler = $this.find('.dropdown-toggle')
            $this.data('toggler', $toggler)
        }

        if ($dropdownMenu == undefined || $dropdownMenu.length == 0) {
            $dropdownMenu = $('#' + $this.find('.kdr-dropdown-w-search-item_selected').data('target'))
            $this.data('dropdownMenu', $dropdownMenu)

            if ($toggler.data('bs.dropdown')._menu == undefined) {
                $toggler.data('bs.dropdown')._menu = $dropdownMenu[0]
            }

        }

        let canBeNewItemP = $dropdownMenu.data('canBeNewItemP')
        if (canBeNewItemP == undefined) {
            let $newItemInput = $dropdownMenu.data('newItemInput')
            let inRenderedNewInput = false

            if ($newItemInput == undefined || $newItemInput.length == 0) {
                $newItemInput = $dropdownMenu.find('.kdr-dropdown-w-search-new-item-input')
                inRenderedNewInput = !($newItemInput == undefined || $newItemInput.length == 0)
            }


            if (inRenderedNewInput === true) {
                $dropdownMenu.data('newItemInput', $newItemInput)
                let $newItemInputContainer = $newItemInput.closest('.kdr-dropdown-w-search-new-item-input-container')
                let $newItemPlaceholder = $dropdownMenu.find('.kdr-dropdown-w-search-item-placeholder')

                $dropdownMenu.find('.kdr-dropdown-w-search-new-item-add, .kdr-dropdown-w-search-new-item-del')
                    .data('newItemPlaceholder', $newItemPlaceholder)
                    .data('newItemInputContainer', $newItemInputContainer)
                    .data('newItemInput', $newItemInput)
                    .data('toggler', $toggler)

                let langInputs = $newItemInputContainer.find('.kdr-dropdown-w-search-new-item-input-container-per-lang').map((i, e) => {
                    return {
                        $input: $(e).find('.kdr-dropdown-w-search-new-item-input'),
                        $flag: $(e).find('.input-group-flag')
                    }
                })
                $newItemInputContainer.data('langInputs', langInputs)

                if ($newItemInput.data('placeholderTextContainer') == undefined) {
                    let $placeholderTextContainer = $dropdownMenu.find('.kdr-dropdown-w-search-item-placeholder .kdr-dropdown-w-search-item-text')
                    $newItemInput.data('placeholderTextContainer', $placeholderTextContainer)
                    let $newInputContainer = $dropdownMenu.find('.kdr-dropdown-w-search-item-placeholder .kdr-dropdown-w-search-item-text')
                    $placeholderTextContainer.data('newItemInputContainer', $newInputContainer)

                    $newItemPlaceholder.data('placeholderTextContainer', $placeholderTextContainer)
                }

            }

            $dropdownMenu.data('canBeNewItemP', inRenderedNewInput)
            $toggler.data('canBeNewItemP', inRenderedNewInput)
        }

        $dropdownMenu.data('toggler', $toggler)
        $toggler.data('oldValue', $toggler.valExtended())

        kdrDropdown.updatePosition($dropdownMenu)
        kdrDropdown.checkSelectedItems($dropdownMenu)
    } else {
        e.preventDefault()
        e.stopPropagation()
        kdrDropdown.removeSelectedItem($dismissItemWithMouseOver)
    }
})

$(document).on('shown.bs.dropdown', '.kdr-dropdown-w-search', function () {
    let $this = $(this)
    let $menu = $this.data().dropdownMenu

    kdrDropdown.initDeleteButton($this)
    let $searchBar = $menu.find('.kdr-dropdown-w-search_bar')
    $searchBar[0].focus({ preventScroll: true })
})

$(document).on('hide.bs.dropdown', '.kdr-dropdown-w-search', function (e) {
    if ($(this).data('isMultiSelecting') === true || $(this).data('dropdownMenu').data('isArrowing') === true) {
        $(this).data('dropdownMenu').data('isArrowing', false)
        e.preventDefault()
    }
})

$(document).on('hidden.bs.dropdown', '.kdr-dropdown-w-search', function () {
    let $this = $(this)
    let $ddl = $this.data().dropdownMenu ?? $this.find(".kdr-dropdown-w-search-menu")

    kdrDropdown.showItems($ddl.find('.kdr-dropdown-w-search-item.hide:not(".kdr-dropdown-w-search-new-item")'))
    kdrDropdown.initDeleteButton($this)
    $ddl.find('.kdr-dropdown-w-search_bar').val('')

    kdrDropdown.checkIfUpdateShouldPerform($this, false)

})

$(document).on('input paste change', '.kdr-dropdown-w-search-select-all-checkbox', function (e) {
    let $this = $(this)
    e.stopPropagation()

    let itemsToSelect = $this.is(':checked')
        ? $this.closest('.kdr-dropdown-w-search-menu').find('.kdr-dropdown-w-search-item-checkbox:visible input:not(:checked)').closest('.kdr-dropdown-w-search-item')
        : $this.closest('.kdr-dropdown-w-search-menu').find('.kdr-dropdown-w-search-item-checkbox:visible input:checked').closest('.kdr-dropdown-w-search-item')
    let $dropdown = $this.closest('.kdr-dropdown-w-search-menu')
    let $toggler = $dropdown.data('toggler')

    kdrDropdown.selectItems($toggler, itemsToSelect);
})

$(document).on('refreshSelectedList', '.kdr-dropdown-w-search_multi .kdr-dropdown-w-search-item_selected', function () {
    kdrDropdown.refreshSelectedList($(this).parent())
})

$(document).on('keydown', '.kdr-dropdown-w-search-menu.show', function (e) {
    let $menu = $(this)
    let $currentlyFocusedItem = $menu.find(':focus')

    if ($currentlyFocusedItem.hasClass('kdr-dropdown-w-search-new-item-input')) {
        return;
    }

    let isCurrentlyFocusedItemSearchInput = $currentlyFocusedItem.hasClass('kdr-dropdown-w-search_bar')
    let $searchInput = $menu.find('.kdr-dropdown-w-search_bar')
    let isDownArrowKey = e.which == 40
    let isUpArrowKey = e.which == 38
    let isEnterKey = e.which == 13

    if (isDownArrowKey === true || isUpArrowKey === true) {
        let $itemToFocus = null

        if (isUpArrowKey) {
            if (isCurrentlyFocusedItemSearchInput) {
                $itemToFocus = $menu.find('.kdr-dropdown-w-search-item').last()
            } else if (0 == $currentlyFocusedItem.prev(':visible').length) {
                $itemToFocus = $searchInput
            } else {
                $itemToFocus = $currentlyFocusedItem.prev(':visible')
            }
        } else if (isDownArrowKey) {
            if (isCurrentlyFocusedItemSearchInput) {
                $itemToFocus = $menu.find('.kdr-dropdown-w-search-item').first()
            } else if (0 == $currentlyFocusedItem.next(':visible').length) {
                $itemToFocus = $searchInput
            } else {
                $itemToFocus = $currentlyFocusedItem.next(':visible')
            }
        }
        e.preventDefault()
        $itemToFocus[0].focus()
    }
    else if (isEnterKey) {
        let $itemToSelect = null
        let $visibleItems = $menu.find('.kdr-dropdown-w-search-item:visible')
        let $toggler = $menu.data().toggler

        if ($currentlyFocusedItem.hasClass('kdr-dropdown-w-search-item')) {
            $itemToSelect = $currentlyFocusedItem
        } else if (isCurrentlyFocusedItemSearchInput && $visibleItems.length == 1) {
            $itemToSelect = $visibleItems
        }

        if ($itemToSelect != null) {
            kdrDropdown.selectItem($toggler, $itemToSelect, false)
            $toggler[0].focus({ preventScroll: true })
        }

    } else {
        $searchInput[0].focus({ preventScroll: true })
    }
})

//$(document).on('change paste input', '.kdr-dropdown-w-search-new-item-input', function () {
//    $(this).data('placeholderTextContainer').text(this.value.trim())
//})

$(document).on('click', '.kdr-dropdown-w-search-new-item-add', function (e) {
    e.stopPropagation()

    let $btn = $(this)
    let inputsCount = $btn.data('newItemInput').length
    let $visibleInput = $btn.data('newItemInput').filter((i, e) => e.checkVisibility())
    let enteredValue = $visibleInput.val()?.trim() ?? ''
    let isAnyInputWithValue = !($btn.data('newItemInput').filter((i, e) => textHelper.isNullOrEmpty(e.value)).length == inputsCount)


    if (!isAnyInputWithValue) {
        let $firstInput = $visibleInput.eq(0) //bo jak mamy wiele jezykow to pierwszy jest zawsze wymagany, a reszte nerwic
        $firstInput.one('animationend', () => $firstInput.removeClass('has-error'))
        $firstInput.addClass('has-error')
        toastr.error($btn.data('errorOnEmpty'))
    } else {
        let $placeholder = $btn.data('newItemPlaceholder')
        $btn.data('newItemInputContainer').hide()

        let languagesP = $btn.data('langs-p')
        if (languagesP === true) {
            let htmlToSet = '';
            let currentLangCode = $btn.data().toggler.data().currentLanguage

            $btn.data('newItemInputContainer').data('langInputs').each((i, e) => {
                let itemLangCode = e.$input.data('language')
                let $newItem = $('<span class="kdr-dropdown-w-search-item-text-placeholder"></span>')
                let newText = e.$input.val()?.trim()

                if (itemLangCode != currentLangCode) {
                    $newItem.hide()
                }

                $newItem
                    .text(newText)
                    .attr('title', newText)
                    .attr('placeholder', e.$input.attr('placeholder'))
                    .attr('empty-p', newText.length == 0)
                    .attr('data-lang', itemLangCode)

                $newItem.append(e.$flag.clone())

                htmlToSet += $newItem.prop('outerHTML')
            })
            $placeholder.data('placeholderTextContainer').html(htmlToSet)
        } else {
            $placeholder.data('placeholderTextContainer')
                .text(enteredValue)
                .attr('title', enteredValue)
        }


        $placeholder.show()
        kdrDropdown.selectItem($btn.data('toggler'), $placeholder, true) //trigger change
    }
})

$(document).on('click', '.kdr-dropdown-w-search-new-item-del', function (e) {
    e.stopPropagation()
    let $btn = $(this)
    $btn.data('newItemPlaceholder').hide()
    $btn.data('newItemInputContainer').show()

    $btn.data('toggler').valExtended(0) //fixme pomyslec jak wyczyscic ddl'ke
})

$(document).on('kdr.changedDisplayedLang', '.kdr-dropdown-w-search-input-w-a-w-lang', function (e) {
    let $btn = $(this)
    let newLangToDisplay = e.newLangCode
    if ($btn.data('currentLanguage') != newLangToDisplay) {
        $btn.data('currentLanguage', newLangToDisplay)

        $btn.add(kdrDropdown.getTogglerMenu($btn)).find('span[data-lang], .kdr-dropdown-w-search-new-item-input-container-per-lang[data-language]').each((i, e) => {
            let $item = $(e)
            let itemLangCode = $item.data('lang') ?? $item.data('language')
            if (itemLangCode != newLangToDisplay) {
                $item.hide()
            }
            else {
                $item.show()
            }
        })
    }

    return $btn;
})


//#endregion Dropdown with search bar